module.exports = __webpack_public_path__ + "img/avatar-btn.bceb343f.png";